module.exports = __webpack_public_path__ + "img/edit.5c0c9f2c.svg";